import 'rxjs/add/operator/map';

import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { PORTUGAL_CODE } from '../helpers/GlobalConstants';
import {AuthService} from '../auth/services/auth.service';

@Injectable()
export class OpenFicheService {
  constructor(private authService: AuthService, private http: HttpClient) {
  }

  public getRequestsToValidate(isPotugal): Observable<any> {
    return isPotugal? this.http.get<any>(environment.api.myshiftUrl+'/support/tovalidate'):this.getRequestsToValidateV2();
  }

  public getRequestsToValidateV2(): Observable<any> {
    return this.http.post<any>(`${environment.api.myshiftUrl}/support/toValidateV2`, this.authService.listDelegation);
  }

  public getRequestsToHistory(): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/support/history', {});
  }

  public getMyRequests(): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/support/requests');
  }

  public validateRequest(id: number): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/support/validate/'+ id);
  }

  public validateRequestList(ids: number[]): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/support/bulk/validate',ids);
  }

  public rejectRequest(id: number): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/support/reject/' + id);
  }

  public rejectRequestList(ids: number[]): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/support/bulk/reject',ids);
  }

  public getHRBPnotifs(): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/support/pending/count');
  }

  public getHRBPUnlockNotifs(): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/requestUnlocking/pending/v2/count',this.authService.listDelegation);
  }
  public getUnlockRequestsToHistory(): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/requestUnlocking/history', {});
  }
  public getMyUnlockRequests(): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/requestUnlocking/requests');
  }
  public getUnlockRequestsToValidate(isPotugal): Observable<any> {
    return isPotugal? this.http.get<any>(environment.api.myshiftUrl+'/requestUnlocking/tovalidate'):this.getUnlockRequestsToValidateV2();
  }

  public getUnlockRequestsToValidateV2(): Observable<any> {
    return this.http.post<any>(`${environment.api.myshiftUrl}/requestUnlocking/toValidateV2`, this.authService.listDelegation);
  }
  public validateUnlockRequest(id: number): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/requestUnlocking/validate/'+ id);
  }

  public rejectUnlockRequest(id: number): Observable<any> {
    return this.http.get<any>(environment.api.myshiftUrl+'/requestUnlocking/reject/' + id);
  }

  public validateUnlockRequestList(ids: number[]): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/requestUnlocking/bulk/validate',ids);
  }

  public rejectUnlockRequestList(ids: number[]): Observable<any> {
    return this.http.post<any>(environment.api.myshiftUrl+'/requestUnlocking/bulk/reject' ,ids);
  }

}

export const configReopenFichePredicate = config => config.countryCode == PORTUGAL_CODE || config.requestOpening;



// WEBPACK FOOTER //
// ./src/app/service/open-fiche.service.ts